<template>
  <div class="daily-pop">
    <div class="daily-pop-btn" @click="handleClick">
      <img src="../../assets/images/save-img.png" alt="壹心理直播">
    </div>
    <div class="dialog-outside" v-show="dialogShow">
      <div class="dialog-mask" @click="dialogShow=false"></div>
      <div class="dialog-inside">
        <div
          class="dialog-inside-con"
          :style="{
            backgroundImage: `url(${dailyImg})`
          }"
        >
          <div class="close-handle" @click="dialogShow=false">
            <svg-icon icon-class="close"></svg-icon>
          </div>
          <p>{{dailyContent}}</p>
        </div>
        <div class="btn-app copyBtn">去App发现更多精彩瞬间</div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadApp } from 'mixins'
export default {
  mixins: [downloadApp],
  data() {
    return {
      dialogShow: false
    }
  },
  props: {
    dailyContent: {
      type: String,
      default: ''
    },
    dailyImg: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.dialogShow = true
      this.$stat.send({
        name: '直播-交互行为',
        properties: {
          业务: '直播详情',
          行为: '点击',
          对象: '图片入口',
          页面: '直播详情页',
          页面title: this.liveData.liveTitle
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.daily-pop {
  .daily-pop-btn {
    width: 72px;
    height: 72px;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 40px;
      height: 36px;
    }
  }
  .dialog-outside {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .dialog-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
  }
  .dialog-inside {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .dialog-inside-con {
    width: 480px;
    height: 740px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    .close-handle {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    p {
      color: #FFF;
      font-size: 26px;
      padding: 0 20px 60px;
    }
  }
  .btn-app {
    color: #FFF;
    font-size: 28px;
    background: #6982FA;
    width: 420px;
    height: 80px;
    border-radius: 40px;
    line-height: 80px;
    text-align: center;
    margin: 30px auto 0;
  }
}
</style>
